import { globalStore, load, mock } from '@/common'
import { model } from './model';
import { HomeApi } from './HomeApi';
import { registerMocks } from './mock';
import { resolveWeekMeetings } from './weekMeetings';

export const initialize = async () => {
    if(mock){
        registerMocks()
    }
    if (!globalStore.isLoaded) {
        await load();
    }
    try {
        model.homeLoadError = null;
        const homeData = await HomeApi.getHomeData();
        const meetings = await resolveWeekMeetings(globalStore.currentUser?.id);
        model.homeData = { ...homeData, ...meetings };
    } catch (e) {
        model.homeLoadError = e instanceof Error ? e.message : String(e);
    }
}   